import { Link } from "react-router-dom";
import SiteHeader from "@/components/landing/SiteHeader";
import Hero from "@/components/landing/Hero";
import ForWho from "@/components/landing/ForWho";
import Inside from "@/components/landing/Inside";
import About from "@/components/landing/About";
import Testimonials from "@/components/landing/Testimonials";
import Faq from "@/components/landing/Faq";
import FinalCta from "@/components/landing/FinalCta";
import useSettings from "@/hooks/useSettings";

export default function Landing() {
  const settings = useSettings();
  return (
    <main className="bg-[#F9F7F3] text-[#1E231F] overflow-x-hidden" data-testid="landing-page">
      <SiteHeader />
      <Hero />
      <ForWho />
      <Inside />
      <About />
      <Testimonials items={settings?.testimonials} />
      <Faq />
      <FinalCta />
      <footer className="border-t border-[#E5E1D8] py-10" data-testid="site-footer">
        <div className="max-w-6xl mx-auto px-5 sm:px-8 flex flex-col sm:flex-row gap-4 justify-between text-sm text-[#5A625C]">
          <p>© {new Date().getFullYear()} Chiara Piccioni · Fitness coach per donne</p>
          <div className="flex gap-6">
            {settings?.instagram_url && (
              <a href={settings.instagram_url} target="_blank" rel="noreferrer" className="link-underline" data-testid="footer-instagram-link">Instagram</a>
            )}
            <Link to="/links" className="link-underline" data-testid="footer-links-link">Tutti i link</Link>
          </div>
        </div>
      </footer>
    </main>
  );
}
